import PropTypes from "prop-types";
import React, { useState } from "react";

import HeadAdminsHeader from "./HeadAdminsHeader";
import HeadAdminModal from "./HeadAdminModal";

const HeadAdmins = (props) => {
  const [headAdmins, setHeadAdmins] = useState(props.head_admins);
  const [headAdmin, setHeadAdmin] = useState(null);

  const [showHeadAdminModal, setShowHeadAdminModal] = useState(false);

  const deleteHeadAdmin = (id) => {
    fetch("/head_admins/" + id, {
      method: "DELETE",
      headers: {
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
      },
    });
    setHeadAdmins((prevAdmins) =>
      prevAdmins.filter((admin) => admin.id !== id),
    );
  };

  const setHeadAdminForModal = (admin) => {
    setHeadAdmin(admin);
    setShowHeadAdminModal(true);
  };

  const headAdminsTable = headAdmins.map((admin) => (
    <tr
      key={admin.id}
      className="bg-white hover:bg-gray-50 border-t border-gray-100"
    >
      <td className="px-4 py-2 flex items-center gap-3">
        <div className="w-8 h-8 bg-gray-200 flex items-center justify-center">
          <svg
            className="w-6 h-6 text-gray-500"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            viewBox="0 0 24 24"
          >
            <path d="M15.75 6.75A3.75 3.75 0 1012 10.5a3.75 3.75 0 003.75-3.75zM4.5 20.25a7.5 7.5 0 1115 0H4.5z" />
          </svg>
        </div>
        {admin.name}
      </td>
      <td className="px-4 py-2">{admin.email}</td>
      <td className="px-4 py-2 space-x-3">
        <button
          className="text-gray-600 hover:text-black"
          onClick={() => setHeadAdminForModal(admin)}
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            viewBox="0 0 24 24"
          >
            <path d="M16.862 3.487a2.062 2.062 0 012.918 2.918l-9.67 9.67a4.125 4.125 0 01-1.733 1.042l-3.133.94.94-3.134a4.125 4.125 0 011.042-1.733l9.67-9.67z" />
          </svg>
        </button>
        <button
          className="text-gray-600 hover:text-black"
          onClick={() => deleteHeadAdmin(admin.id)}
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            viewBox="0 0 24 24"
          >
            <path d="M6 7h12M10 11v6m4-6v6M4 7h16l-1 12.25A1.75 1.75 0 0117.25 21H6.75A1.75 1.75 0 015 19.25L4 7zM9 7V4.75A1.75 1.75 0 0110.75 3h2.5A1.75 1.75 0 0115 4.75V7" />
          </svg>
        </button>
      </td>
    </tr>
  ));

  return (
    <>
      {showHeadAdminModal && (
        <HeadAdminModal
          headAdmin={headAdmin}
          headAdmins={headAdmins}
          setHeadAdmins={setHeadAdmins}
          setShowHeadAdminModal={setShowHeadAdminModal}
        />
      )}
      <HeadAdminsHeader headAdmins={headAdmins} setHeadAdmins={setHeadAdmins} />
      <div className="h-full overflow-auto max-h-[70vh]">
        <table className="min-w-full border-collapse">
          <thead>
            <tr className="bg-gray-50 text-left text-sm text-gray-600">
              <th className="px-4 py-2 font-medium">
                <div className="flex items-center gap-1">
                  Imię i Nazwisko
                  <svg
                    className="w-3 h-3"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path d="M8 9l4-4 4 4m0 6l-4 4-4-4" />
                  </svg>
                </div>
              </th>
              <th className="px-4 py-2 font-medium">
                <div className="flex items-center gap-1">
                  Adres email
                  <svg
                    className="w-3 h-3"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path d="M8 9l4-4 4 4m0 6l-4 4-4-4" />
                  </svg>
                </div>
              </th>
              <th className="px-4 py-2 font-medium">Action</th>
            </tr>
          </thead>
          <tbody className="text-sm">{headAdminsTable}</tbody>
        </table>
      </div>
    </>
  );
};

HeadAdmins.propTypes = {
  head_admins: PropTypes.array,
};

export default HeadAdmins;
